<template>
    <div class="pa-2">
        <h2>Edit Expected Transaction</h2>                
       <expected-transaction-form :expectedTransaction="expectedTransaction" @save="save" @deleteClicked="deleteClicked" />       
    </div>
</template>

<script>

import { apiPost,apiDelete } from '../../../dal';
import ExpectedTransactionForm from '../components/ExpectedTransactionForm.vue'
export default {
  components: {  ExpectedTransactionForm },
  name: "EditExpectedTransaction",
  props: {
    id: {    
      required: true
    },
  },
  
  data() {
        return {

        };
    },

    mounted() {
        if(this.$store.state.expectedTransactions.length==0){
            this.$store.dispatch("getExpectedTransactions");
        }        
    },
     
    computed:{
        expectedTransaction(){
            if(this.id>0 && this.$store.state.expectedTransactions.length>0){
                return this.$store.state.expectedTransactions.find(item=>item.ID == this.id);
            }
            return {
                TRANSACTION_DATE: null,
                SUPPLIER: null,
                AMOUNT: null,
                DESCRIPTION: "",
                CATEGORY_ID: null,
                ID: null,
                TRANSACTION_ID: null
            };            
        }
    },

    methods: {
        deleteClicked(expectedTransaction) {
            if (confirm("Are you sure you want to delete this transaction?")) {
                apiDelete("expected-transactions/"+ expectedTransaction.ID).then(() => {
                    this.$store.dispatch("getExpectedTransactions");
                    this.$router.push({ name: "expectedTransactions" });
                });
            }
        },

        save(expectedTransaction) {            
             apiPost("expected-transactions", expectedTransaction).then(() => {
                 this.$store.dispatch("getExpectedTransactions");
                 this.$router.push({ name: "expectedTransactions" });                
             });                    
        }
    }
}




</script>


<style>

</style>